import getIds from "./getIds";
import { ToolGroupManager, CrosshairsTool } from "@cornerstonejs/tools";
import viewerState from "stores/viewer";
import settingsState, { updateWindowLevel } from "stores/settings";
import { utilities as csUtils } from "@cornerstonejs/core";
import { isProgrammaticVOI } from "./voiState";

export function crosshairRenderingListener() {
  const { viewerId } = viewerState;
  if (!viewerId) return;
  const { toolGroupId } = getIds();
  const toolGroup = ToolGroupManager.getToolGroup(toolGroupId);
  if (!toolGroup) return;
  const tool = toolGroup.getToolInstance(CrosshairsTool.toolName);
  if (!tool?.editData?.annotation) return;
  const center = tool.editData.annotation.data.handles.toolCenter;
  const rotationPoint =
    tool.editData.annotation.data.handles.rotationPoints?.[0]?.[0];
  const relativeCoordinates = center.map(
    (c: number, i: number) =>
      Math.round((rotationPoint?.[i] - c) * 1000) / 1000,
  );
  const isNotTranslation =
    tool.editData.annotation.data.activeViewportIds?.length === 0;
  if (
    relativeCoordinates.filter((r: number) => Math.abs(r) > 1).length > 1 &&
    isNotTranslation
  ) {
    settingsState.showOrientationLabel = false;
  }
}

export function voiModifiedListener(event: CustomEvent) {
  // Skip if this was triggered by our own programmatic change
  if (isProgrammaticVOI()) {
    return;
  }

  const detail = event.detail;

  // v4 API: detail.voiRange or detail.range
  // Try both structures for compatibility
  let lower: number | undefined;
  let upper: number | undefined;

  if (detail.voiRange) {
    // v4 structure
    lower = detail.voiRange.lower;
    upper = detail.voiRange.upper;
  } else if (detail.range) {
    // v1.66 structure
    lower = detail.range.lower;
    upper = detail.range.upper;
  }

  if (lower === undefined || upper === undefined) {
    // Can't extract VOI range, skip
    return;
  }

  const { windowWidth: width, windowCenter: center } =
    csUtils.windowLevel.toWindowLevel(lower, upper);

  // Only update if values actually changed (with small tolerance for floating point)
  const currentWidth = settingsState.windowLevel.width;
  const currentCenter = settingsState.windowLevel.center;

  if (
    Math.abs(width - currentWidth) < 0.5 &&
    Math.abs(center - currentCenter) < 0.5
  ) {
    return;
  }

  updateWindowLevel({ width, center });
}
